// extracted by mini-css-extract-plugin
module.exports = {"avatarColorsHolder":"ManageAvatarColorsPopup_avatarColorsHolder__12pcl","column1":"ManageAvatarColorsPopup_column1__2bie5","column2":"ManageAvatarColorsPopup_column2__GA3YO"};